module.exports = __webpack_public_path__ + "img/undraw_researching_22gp.996adf1e.png";